export class ProspectImportSearchRequest {
  dateFrom: number;
  dateTo: number;
}
